import { niubizResponseResolver } from '@modules/payment/resolvers/niubiz-response';
import { propOr, tryCatch, always } from 'ramda';
import * as moment from 'moment';

export const paymentResponseResolver = ({
  raw,
  statusCode,
}: any): NiubizAuthorizationResponse => {
  const getFrom = (defaultVal, field) => propOr(defaultVal, field, raw);
  const serviceResponse = getFrom('', 'service_response');

  return {
    statusCode,
    transactionId: getFrom(0, 'id_transaction'),
    user: getFrom('', 'user'),
    userId: getFrom('', 'user_id'),
    memberNumber: getFrom('', 'num_member'),
    clubTicker: getFrom('', 'club_ticket'),
    amount: getFrom(0, 'amount'),
    state: getFrom('', 'state'),
    cardBrand: getFrom('', 'card_brand'),
    cardPan: getFrom('', 'card_pan'),
    payedItems: tryCatch(
      (i) => JSON.parse(i),
      always([])
    )(getFrom('', 'items')),
    visaTransactionResponse: niubizResponseResolver({
      raw: serviceResponse.dataMap || serviceResponse.data,
    }),
    transactionDateFormatted: moment
      .utc(getFrom('', 'updated_at'))
      .local()
      .format('YYYY-MM-DD HH:mm:ss'),
  };
};
